//src/shared/services/services
import api from "../../features/auth/axiosConfig";
import { Configurations } from "./interface";

const version = "v2";

// POS
const user = `pos/${version}/user_details`;
const themes = `/pos/${version}/theme`;
const orderReturn = "/app/v1/pos/order_reverse";
const profile = `pos/profile`;
const profileAdd = `pos/add`;
const ledger = `pos/ledger`;
const ledgerCustomer = `pos/${version}/ledger/customer`;

// APP POS
const product = `app/pos/${version}/product`;
const category = `app/pos/${version}/category`;
const customer = `app/pos/${version}/customer`;
const orderEndpoint = `app/pos/${version}/order`;
const cancelOrder = `app/pos/${version}/cancel_order?orderid=`;
const dashboard = `app/pos/${version}/dashboard`;
const staff = `app/pos/${version}/staff`;
const uom = `app/pos/${version}/uom`;

// IMPORT / EXPORT
const categotyExport = `app/${version}/export/category`;
const categotyImport = `app/${version}/import/category`;
const productExport = `app/${version}/export/product`;
const productImport = `app/${version}/import/product`;

// EMPLOYEE
const employee = `/pos/${version}/add_employee`;
const getemployee = `/pos/${version}/get_user`;

// CONFIG
const configEndpoint = `app/pos/${version}/configuration`;
const OrderReverse = `app/pos/${version}/reverse_order?orderid=`;

export const getUser = async () => {
  try {
    const responce = await api.get(user);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getProduct = async (
  data?: boolean,
  page?: number,
  row?: number,
  search?: string,
  categoryid?: string,
  sortField?: string,
  order?: string,
) => {
  try {
    const responce = await api.get(
      `${product}?include_deleted=${data || "false"}&pageNumber=${page || ""}&pageSize=${row || ""}&searchBy=${search || ""}&category_id=${categoryid || ""
      }&sortField=${sortField || ""}&sortOrder=${order || ""}`,
    );
    return responce;
  } catch (error) {
    throw error;
  }
};

export const postProduct = async (data: any) => {
  try {
    const responce = await api.post(product, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return responce;
  } catch (error) {
    throw error;
  }
};

export const putProduct = async (id: string, data: any) => {
  try {
    const responce = await api.put(`${product}/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return responce;
  } catch (error) {
    throw error;
  }
};

export const deleteProduct = async (data: any) => {
  try {
    const responce = await api.delete(product, { data: { ids: data } });
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getCategory = async (data?: boolean, page?: number, row?: number, search?: string, sortField?: string, order?: string) => {
  try {
    const responce = await api.get(
      `${category}?include_deleted=${data || false}&pageNumber=${page || 1}&pageSize=${row || ""}&searchBy=${search || ""}&sortField=${sortField || ""
      }&sortOrder=${order || ""}`,
    );
    return responce;
  } catch (error) {
    throw error;
  }
};

export const postCategory = async (data: any) => {
  try {
    const responce = await api.post(category, data);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const patchCategory = async (data: any, id: string) => {
  try {
    const responce = await api.put(`${category}/${id}`, data);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const deleteCategory = async (data: any) => {
  try {
    const responce = await api.delete(category, { data: { ids: data } });
    return responce;
  } catch (error) {
    throw error;
  }
};

export const postCustomer = async (customerData: any) => {
  try {
    const responce = await api.post(customer, customerData);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const putCustomer = async (id: string, customerData: any) => {
  try {
    const responce = await api.put(`${customer}/${id}`, customerData);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const patchCustomer = async (id: string, customerData: any) => {
  try {
    const responce = await api.patch(`${customer}/${id}`, customerData);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getCustomer = async (sataus?: boolean, page?: number, row?: number, searchTerm?: string, sortField?: string, order?: string) => {
  try {
    const url = `${customer}?include_deleted=${sataus || false}&pageNumber=${page}&pageSize=${row}&searchBy=${searchTerm || ""
      }&sortField=${sortField}&sortOrder=${order}`;
    const responce = await api.get(url);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const deleteCustomer = async (data: any) => {
  try {
    const responce = await api.delete(customer, { data: { ids: data } });
    return responce;
  } catch (error) {
    throw error;
  }
};

export const postOrder = async (postData: any) => {
  try {
    const responce = await api.post(orderEndpoint, postData);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getOrder = async (
  id?: string,
  page?: number,
  limit?: number,
  from?: string,
  to?: string,
  name?: string,
  staff?: string,
  sortField?: string,
  order?: string,
  status?: string,
) => {
  const url = id ? `${orderEndpoint}/${id}` : orderEndpoint;
  const pageURL = `${orderEndpoint}?pageNumber=${page}&pageSize=${limit}&dateFilter=custom&startDate=${from}&endDate=${to}&searchBy=${name || ""
    }&staff_name=${staff}&sortField=${sortField}&sortOrder=${order}&status=${status}`;
  const orderUrl = page ? pageURL : url;
  try {
    const responce = await api.get(orderUrl);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const orderReturnId = async (id: string, data: any) => {
  const url = `${orderReturn}/${id}`;
  try {
    const responce = await api.put(url, data);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const patchOrder = async (id: string, data: any) => {
  const url = `${orderEndpoint}/${id}`;
  try {
    const responce = await api.patch(url, data);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const exportCategory = async () => {
  try {
    const responce = await api.get(categotyExport, {
      responseType: "blob",
    });
    return responce;
  } catch (error) {
    throw error;
  }
};

export const importCategory = async (file: any) => {
  try {
    const responce = await api.post(categotyImport, file, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return responce;
  } catch (error) {
    throw error;
  }
};
export const exportProduct = async () => {
  try {
    const responce = await api.get(productExport, {
      responseType: "blob",
    });
    return responce;
  } catch (error) {
    throw error;
  }
};

export const importProduct = async (file: any) => {
  try {
    const responce = await api.post(productImport, file, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return responce;
  } catch (error) {
    throw error;
  }
};

export const putTheme = async (file: any) => {
  try {
    const responce = await api.put(themes, file);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getProfile = async () => {
  try {
    const responce = await api.get(profile);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const putProfile = async (file: any, Id: string) => {
  try {
    const responce = await api.put(`${profile}/${Id}`, file);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getLedgers = async (page?: number, pageSize?: number, searchBy?: string, sortField?: string, order?: string, osbnull?: boolean) => {
  const ledgerPageView = `${ledger}?pageNumber=${page}&pageSize=${pageSize}&searchBy=${searchBy}&sortField=${sortField}&sortOrder=${order}&includeSettled=${osbnull}`;
  try {
    const responce = await api.get(ledgerPageView);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getLedgersId = async (id: string) => {
  try {
    const responce = await api.get(`${ledger}/${id}`);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const postLedgers = async (data: any) => {
  try {
    const responce = await api.post(ledger, data);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getLedgersCustomer = async (id: string) => {
  try {
    const responce = await api.get(`${ledgerCustomer}/${id}`);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const putMyProfile = async (file: any, Id: string) => {
  try {
    const responce = await api.put(`${profileAdd}/${Id}`, file);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const dashBoard = async (From?: string, to?: string) => {
  const url = From && to ? `${dashboard}?start_date=${From}&end_date=${to}` : dashboard;
  try {
    const responce = await api.get(url);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const staffData = async () => {
  const url = `${staff}?include_deleted=false`;
  try {
    const response = await api.get(url);
    return response;
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async (token: string, newPassword: string, confirmPassword: string) => {
  try {
    const response = await api.post(`/v2/reset-password/${token}`, {
      newPassword: newPassword,
      confirmPassword: confirmPassword,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// UOM APIs

export const getUOM = async () => {
  try {
    const res = await api.get(uom);
    return res;
  } catch (error) {
    throw error;
  }
};

export const postUOM = async (uomInput: any) => {
  try {
    const res = await api.post(uom, uomInput);
    return res;
  } catch (error) {
    throw error;
  }
};

export const exportOrder = async (
  exportFormate: string,
  search: string,
  pageNumber: number,
  pageSize: number,
  startDate: string,
  endDate: string,
  OrderStatus: string,
) => {
  try {
    const responce = await api.get(
      `${`app/v2/import_export?export=${exportFormate}`
      }&searchBy=${search}&pageNumber=${pageNumber}&pageSize=${pageSize}&dateFilter=custom&startDate=${startDate}&endDate=${endDate}&OrderStatus=${OrderStatus}`,
    );
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getLogo = async (imagePath: string) => {
  try {
    // 🚨 Block empty or non-png extensions
    if (!imagePath || !imagePath.toLowerCase().endsWith(".png")) {
      return null;
    }
    const res = api.get(`/pos/v2/logo?filename=${imagePath}`, { responseType: "arraybuffer" });
    return res;
  } catch (error: any) {
    // 🚨 Silently ignore 404
    if (error?.response?.status === 404) {
      return null;
    }
    console.error(error);
    throw error;
  }
};

// /app/pos/v2/configuration

export const GetConfigurationPageSetup = async () => {
  try {
    const res = api.get(configEndpoint);
    return res;
  } catch (error) {
    console.error(error);
  }
};

export const postConfigurationPageSetup = async (pageConfiguration: Configurations) => {
  try {
    const res = api.put(configEndpoint, pageConfiguration, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res;
  } catch (error) {
    console.error(error);
  }
};

export const patchConfigurationPageSetup = async (pageConfiguration: any) => {
  try {
    const res = api.put(configEndpoint, pageConfiguration, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res;
  } catch (error) {
    console.error(error);
  }
};

//order cancel api

export const putCancelOrder = async (id: string, data: any) => {
  const url = `${cancelOrder}${id}`;
  try {
    const responce = await api.put(url, data);
    return responce;
  } catch (error) {
    throw error;
  }
};
export const putOrderEdit = async (id: string, data: any) => {
  const url = `${OrderReverse}/${id}`;
  try {
    const responce = await api.put(url, data);
    return responce;
  } catch (error) {
    throw error;
  }
};

// employee management APIs

export const postEmployee = async (data: any) => {
  const url = `${employee}`;
  try {
    const responce = await api.post(url, data);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const getEmployee = async () => {
  const url = `${getemployee}`;
  try {
    const responce = await api.get(url);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const editEmployee = async (id: string, data: any) => {
  const url = `${employee}/${id}`;
  try {
    const responce = await api.put(url, data);
    return responce;
  } catch (error) {
    throw error;
  }
};

export const deleteEmployee = async (id: string) => {
  const url = `${employee}/${id}`;
  try {
    const responce = await api.delete(url);
    return responce;
  } catch (error) {
    throw error;
  }
};
